import { AddNewAmenitiesModal } from "molecules/Modals/AddNewAmenitiesModal";
import React from "react";

import MasterTemplateTable from "templates/Master/MasterTemplateTable";
import api from "utils/api";

const Amenities = () => {
  return (
    <MasterTemplateTable
      actions={{
        get: async () => {
          try {
            const { data } = await api("/amenities/get", {
              method: "get",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        create: async ({ name, icon }) => {
          try {
            const reqData = { name, icon };
            const { data } = await api("/amenities/add", {
              method: "post",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        update: async (id, { name, icon }) => {
          try {
            const reqData = { name, icon };
            const { data } = await api(`/amenities/update/${id}`, {
              method: "put",
              data: reqData,
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
        remove: async (id) => {
          try {
            const { data } = await api(`/amenities/delete/${id}`, {
              method: "delete",
            });

            return data;
          } catch (e) {
            throw e;
          }
        },
      }}
      pageHeading="Amenties"
      addRecord="Add Amenities"
      searchRecord="Search Amenities"
      table={{
        tableHeader: [
          {
            name: "Name",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
          {
            name: "Actions",
            containerProps: {
              fontSize: "1.4rem",
              fontWeight: "600",
            },
          },
        ],
        tableRowDatas: [
          {
            render: (record) => <td>{record?.name}</td>,
          },
        ],
        actions: { editable: true, removable: true },
      }}
      actionModal={{ title: "Amenities", CustomModal: AddNewAmenitiesModal }}
    />
  );
};

export default Amenities;
